import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { startUpdateChecker } from "./lib/updateChecker";

startUpdateChecker();

const root = createRoot(document.getElementById("root")!);
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Signal the prerenderer that the page is ready.
// We poll until <title> changes from the default index.html title OR a max wait passes.
// This handles async data-loading routes (e.g. /insights/* fetching custom_articles).
if (typeof window !== "undefined") {
  const DEFAULT_TITLE = "R0 Hub | CII Exam Practice Questions R01 - R06";
  const MAX_WAIT_MS = 6000;
  const CHECK_INTERVAL_MS = 150;
  const start = Date.now();

  const fire = () => document.dispatchEvent(new Event("render-event"));

  const check = () => {
    const elapsed = Date.now() - start;
    const titleChanged = document.title && document.title !== DEFAULT_TITLE;
    // Fire when title has been updated (Helmet flushed) OR max wait reached
    if (titleChanged || elapsed >= MAX_WAIT_MS) {
      // small buffer so any in-flight DOM mutations settle
      setTimeout(fire, 200);
      return;
    }
    setTimeout(check, CHECK_INTERVAL_MS);
  };

  // Wait one frame so React mounts before we start checking
  requestAnimationFrame(() => setTimeout(check, 100));
}
